import { render, staticRenderFns } from "./TagStatus.vue?vue&type=template&id=036b32dc"
import script from "./TagStatus.vue?vue&type=script&lang=js"
export * from "./TagStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports